import entity from './entity';
import { get } from '../../../../utils/state';

const {
  getByIdFromState,
  getByIdsFromState,
} = entity.getSelectors();

const getRegistrantDetailsFromState = eventId => state => get(state, `entities.hiringEvents.data.${eventId}.registrant_details`, {});
const getIsLoadingFromState = state => get(state, 'entities.hiringEvents.isLoading');
const getIsUpdatingFromState = state => get(state, 'entities.hiringEvents.isUpdating');
const getHiringEventsFromState = state => get(state, 'entities.hiringEvents.data', {});
const getTotalHiringEventsFromState = state => get(state, 'entities.hiringEvents.pagination.totalElements');
const getNewHiringEventIdFromState = state => get(state, 'entities.hiringEvents.newEventId', null);
const getHiringEventsPaginationFromState = state => get(state, 'entities.hiringEvents.pagination', {});
const getHiringEventErrorFromState = state => get(state, 'entities.hiringEvents.error', null);


const state = {
  getEventsByIds: getByIdsFromState,
  getEventById: getByIdFromState,
  getRegistrantDetails: getRegistrantDetailsFromState,
  getIsLoading: getIsLoadingFromState,
  getIsUpdating: getIsUpdatingFromState,
  getHiringEvents: getHiringEventsFromState,
  getNewEventId: getNewHiringEventIdFromState,
  getHiringEventsPagination: getHiringEventsPaginationFromState,
  getTotalEvents: getTotalHiringEventsFromState,
  getHiringEventsError: getHiringEventErrorFromState,
};

export const {
  getEventsByIds,
  getEventById,
  getRegistrantDetails,
  getIsLoading,
  getIsUpdating,
  getHiringEvents,
  getNewEventId,
  getHiringEventsPagination,
  getTotalEvents,
  getHiringEventsError,
} = state;

export default state;
